import $ from 'jquery';
// import MyModule from 'modules/MyModule'

export default class Main {
  constructor() {
    console.log('init');
  }
}



/** WEBPACK FOOTER **
 ** ./site.js
 **/